// `localeMappings` (and its `date-fns/locale` imports) moved to
// `@/lib/locales.ts` so that this types module is free of value-level
// date-fns dependencies. Many widely-used files import enums from here;
// keeping date-fns out of the module avoids dragging ~50 KB of locale
// data into every chunk that touches a `@/lib/types` enum.
export enum AddressType {
  Property = 1,
  Mailing = 2,
  Residential = 3,
  Other = 4,
}

export interface Address {
  type?: AddressType;
  unitNumber?: string;
  addressLine: string;
  city: string;
  state: string;
  country: string;
  postCode: string;
}

export interface AddressCoords {
  lat: number;
  long: number;
}
export enum DocumentImageSize {
  'thumb' = 'thumb',
  'xs' = 'xs',
  's' = 's',
  'm' = 'm',
  'l' = 'l',
  'xl' = 'xl',
}

export interface ResponseValidationErrors {
  [fieldName: string]: string[];
}

export enum SortOrderEnum {
  ASC = 'asc',
  DESC = 'desc',
}

export enum TabOrientation {
  Horizontal = 'row',
  Vertical = 'column',
}

export enum UserRole {
  /** Backend RoleSeed "Admin" — per-org society/tenant admin (RoleId 11). */
  SocietyAdmin = 11,
  Breeder = 2,
  /** Backend RoleSeed "Breedlogic Admin" — global ABRI admin (RoleId 18). */
  Admin = 18,
}

/**
 * Role IDs that grant per-organisation admin privileges within the registry
 * (e.g. access to `/config`).
 */
export const ADMIN_ROLES: ReadonlyArray<UserRole> = [
  UserRole.SocietyAdmin,
  UserRole.Admin,
];

export const isAdminRole = (roleId: number | null | undefined): boolean =>
  roleId != null && ADMIN_ROLES.includes(roleId as UserRole);

export enum UserRoleName {
  Admin = 'Breedlogic Admin',
}

enum ContactType {
  Email = 1,
  Phone = 2,
  Mobile = 3,
  Fax = 4,
}

export const phoneNumberTypes = [
  { id: ContactType.Phone, name: 'Home' },
  { id: ContactType.Mobile, name: 'Mobile' },
  { id: ContactType.Fax, name: 'Fax' },
];

export enum EventType {
  BUTTON_CLICK = 'ButtonClick',
  NAVIGATION_CLICK = 'NavigationClick',
  FORM_SUBMIT = 'FormSubmit',
  INPUT_CHANGE = 'InputChange',
  INPUT_FOCUS = 'InputFocus',
  DROPDOWN_SELECT = 'DropdownSelect',
  TAB_SWITCH = 'TabSwitch',
  DIALOG_INTERACTION = 'DialogInteraction',
  CHECKBOX_TOGGLE = 'CheckboxToggle',
  VIEW_CLICK = 'ViewClick',
  LOGIN = 'Login',
}
